interface UpgradeBannerProps {
  feature: string
  plan: string
  description?: string
}

export function UpgradeBanner({ feature, plan, description }: UpgradeBannerProps) {
  return (
    <div style={{
      maxWidth: 480, margin: '80px auto', textAlign: 'center', padding: 40,
      borderRadius: 12, background: 'var(--bg-surface)', border: '1px solid var(--border)',
      boxShadow: 'var(--shadow-lg)',
    }}>
      <div style={{ fontSize: 40, marginBottom: 16, opacity: 0.6 }}>&#x2B50;</div>
      <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 8 }}>{feature}</h2>
      {description && (
        <p style={{ color: 'var(--text-secondary)', marginBottom: 20, fontSize: 14, lineHeight: 1.5 }}>
          {description}
        </p>
      )}
      <div style={{
        display: 'inline-block', padding: '4px 12px', borderRadius: 20,
        background: 'var(--accent-m)', color: 'var(--accent)',
        fontSize: 12, fontWeight: 600, marginBottom: 20, border: '1px solid var(--accent-m)',
      }}>
        Requires {plan} Plan
      </div>
      <div>
        <button
          className="v3-btn v3-btn-primary"
          style={{
            background: 'linear-gradient(135deg, var(--accent), var(--accent-h))',
            border: 'none', padding: '10px 24px', borderRadius: 8, color: '#fff',
            fontWeight: 600, fontSize: 14, cursor: 'pointer',
          }}
          onClick={() => window.open('mailto:sales@ambersecurity.net?subject=Plan Upgrade Inquiry', '_blank')}
        >
          Contact Sales to Upgrade
        </button>
      </div>
    </div>
  )
}
